<div style="margin-left: 45%; margin-top: 250px;">
  <form [formGroup]="form" style="display: inline-grid;">
    <mat-form-field appearance="standard" color="standart">
      <mat-label>{{"home.login.username" | translate }}</mat-label>
      <input matInput formControlName="username" autocomplete="on">
    </mat-form-field>

    <mat-form-field appearance="standard" color="standart">
      <mat-label>{{"home.login.password" | translate }}</mat-label>
      <input type="password" matInput formControlName="password" autocomplete="on">
    </mat-form-field>
  </form>
  <div class="validation-error" *ngIf="showError">
    <label>{{"admin.login.invalidPassword" | translate}}</label>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="submit()" style="width: 180px">{{'home.login.submit' | translate}}</button>
  </div>
</div>
